import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "jz-statistic"
};
const _hoisted_2 = {
  class: "jz-statistic__head"
};
const _hoisted_3 = {
  class: "jz-statistic__content single-line"
};
import { number } from "echarts";
export default {
  __name: 'Statistic',
  props: {
    title: String,
    value: String | number | Object
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(props.title), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString(__props.value), 1)])]);
    };
  }
};